import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import IconSinister from '@mercadoni/sinister/dist/cjs/Icon'

const IconLogic = ({ icon }: { icon: string }) => {
  const { isMobile } = useHeaderContext()

  const style = {
    marginRight: 'var(--spacing-margin-xSmall)',
    flexShrink: '0',
    color: `var(--app-location-icon-color-${isMobile ? 'mobile' : 'desktop'})`,
  }

  return <IconSinister size={20} className={icon} style={style} />
}

const Icon = ({ icon }: { icon: string }) => <IconLogic icon={icon} />

export default Icon
